import { render, staticRenderFns } from "./Contest.vue?vue&type=template&id=a4f23dde&"
import script from "./Contest.vue?vue&type=script&lang=js&"
export * from "./Contest.vue?vue&type=script&lang=js&"
import style0 from "./Contest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports